import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOneplusComponent } from './simple-icons-oneplus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOneplusComponent ],
    exports:      [ SimpleIconsOneplusComponent ],
    bootstrap:    []
})
export class SimpleIconsOneplusModule {}
